import gql from 'graphql-tag';

import { ORGANIZER_FRAGMENT } from './organizer';
import { LANGUAGE_FRAGMENT } from './language';
import { ACTIVITY_FRAGMENT } from './activity';
import { TOPIC_FRAGMENT } from './topic';

export const PROJECT_PREVIEW_FRAGMENT = gql`
  fragment projectPreview on ProjectPreviewType {
    id
    name
    organizer {
      ...organizer
    }
    createdAt
    updatedAt
    projectDescription
    volunteerDescription
    contactPerson
    contactEmail
    contactInformations
    addressCity
    addressAdminLevel1
    addressNoLocationDetails
    addressFull
    addressCountry
    addressPostalCode
    addressLocation {
      latitude
      longitude
    }
    languages {
      edges {
        node {
          ...language
        }
      }
    }
    activities {
      edges {
        node {
          ...activity
        }
      }
    }
    topics {
      edges {
        node {
          ...topic
        }
      }
    }
    isPromoted
    isPublished
    isProjectBadgeActivated
    headerImage
  }
  ${TOPIC_FRAGMENT}
  ${ACTIVITY_FRAGMENT}
  ${LANGUAGE_FRAGMENT}
  ${ORGANIZER_FRAGMENT}
`;
